export class DocumentUpdateFolderModel {
  DocumentFolderID: string;
  DocumentName: string;
}
